<div class="flex">
    <div *ngIf="facebookMedias.length==1" class=" bg-black w-full flex-grow">
        <img  class="mx-auto max-h-[360px]" src="{{facebookMedias[0].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[0])}" alt="Post Image" style="display: block;">
    </div>
    <div *ngIf="facebookMedias.length==2" class="flex-grow">
        <div *ngIf="orientation=='landscape'" class="grid grid-rows-2 " >
            <img class=" object-cover object-center" src="{{facebookMedias[0].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[0])}">
            <img class=" object-cover object-center" src="{{facebookMedias[1].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[1])}">
        </div>
        <div *ngIf="orientation=='square'" class="grid grid-cols-2" [style.height]="imgContainerHeight(2)">
            <img class="w-full object-cover object-center" src="{{facebookMedias[0].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[0])}">
            <img class="w-full object-cover object-center" src="{{facebookMedias[1].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[1])}">
        </div>
        <div *ngIf="orientation=='portrait'" class="grid grid-cols-2 " >
            <img class="w-full  object-cover object-center" src="{{facebookMedias[0].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[0])}">
            <img class="w-full  object-cover object-center" src="{{facebookMedias[1].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[1])}">
        </div>
    </div>
    <div *ngIf="facebookMedias.length==3" class="flex-grow">
        <div class="container flex flex-row w-full h-[371px] bg-black">
            <div class="w-1/2 h-full flex items-center justify-center ">
                <!-- Div 1 -->
                <p><img class=" object-cover object-center" src="{{facebookMedias[0].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[0])}"></p>
            </div>
            <div class="w-1/2 flex flex-col">
                <div class="h-1/2 flex items-center justify-center">
                    <!-- Div 2 -->
                    <p><img class="max-h-[180px] object-cover object-center" src="{{facebookMedias[1].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[1])}"></p>
                </div>
                <div class="h-1/2 flex items-center justify-center">
                    <!-- Div 3 -->
                    <p><img class="max-h-[180px] object-cover object-center" src="{{facebookMedias[2].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[2])}"></p>
                </div>
            </div>
            <!-- <div *ngIf="orientation=='square' || orientation== 'FirstImglandscape'" class="grid grid-cols-2 grid-rows-2 gap-0 " >
                <div class="col-span-2 gap-0 row-span-1">
                    <img class="max-h-[360px] object-cover object-center" src="{{facebookMedias[0].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[0])}">
                </div>  
                <div class="grid grid-cols-2 gap-0 col-span-2 row-span-2">
                    <img class="max-h-[180px] object-cover object-center" src="{{facebookMedias[1].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[1])}">
                    <img class="max-h-[180px] object-cover object-center" src="{{facebookMedias[2].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[2])}">
                </div>
            </div>
            <div *ngIf="orientation == 'landscape' || orientation == 'FirstImgsquare'" class="grid grid-rows-3 gap-0 " >
                <div class="row-span-2 relative w-full max-h-[360px]">
                    <img class="absolute inset-0 w-full max-h-[360px] object-cover object-center" src="{{facebookMedias[0].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[0])}">
                </div>
                <div class="grid grid-cols-2 gap-0 row-span-1 w-full max-h-[360px]">
                    <div class="relative w-full max-h-[180px]">
                        <img class="absolute inset-0 w-full max-h-[180px] object-cover object-center" src="{{facebookMedias[1].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[1])}">
                    </div>
                    <div class="relative w-full max-h-[180px]">
                        <img class="absolute inset-0 w-full max-h-[180px] object-cover object-center" src="{{facebookMedias[2].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[2])}">
                    </div>
                </div>
            </div>
            <div *ngIf="orientation=='portrait' || orientation=='FirstsquareRestportrait'" class="grid grid-cols-3 gap-0 " >
                <div  class="col-span-2">
                    <img class="w-full max-h-[360px] object-cover object-center" src="{{facebookMedias[0].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[0])}">
                </div>  
                <div  class="gird grid-cols-3 col-span-1 gap-0">
                    <img class="w-full max-h-[180px] object-cover object-center" src="{{facebookMedias[1].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[1])}">
                    <img class="w-full max-h-[180px] object-cover object-center" src="{{facebookMedias[2].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[2])}">
                </div>
            </div>
            <div *ngIf="orientation=='FirstImgportrait'" class="grid grid-cols-2 gap-0 " >
                <div class="" >
                    <img class="w-full max-h-[360px] object-cover object-center" src="{{facebookMedias[0].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[0])}">
                </div>
                <div  class="gird grid-cols-3 gap-0">
                    <img class="w-full max-h-[180px] object-cover object-center" src="{{facebookMedias[1].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[1])}">
                    <img class="w-full max-h-[180px] object-cover object-center" src="{{facebookMedias[2].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[2])}">
                </div>
            </div> -->
        </div>
    </div>
    <div *ngIf="facebookMedias.length==4">
        <div *ngIf="orientation == 'landscape' || orientation == 'FirstImgsquare'" class="grid grid-rows-[2fr_1fr] gap-0 " >
            <div class="row-span-2">
                <img class="w-full h-full object-cover object-center" src="{{facebookMedias[0].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[0])}">
            </div>
            <div class="grid grid-cols-3 gap-0 row-span-1">
                <img class="w-full h-full object-cover object-center" src="{{facebookMedias[1].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[1])}">
                <img class="w-full h-full object-cover object-center" src="{{facebookMedias[2].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[2])}">
                <img class="w-full h-full object-cover object-center" src="{{facebookMedias[3].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[3])}">
            </div>
        </div>    
        <div *ngIf="orientation=='portrait' || orientation=='FirstsquareRestportrait'" class="grid grid-cols-3 gap-0 " >
            <div  class="col-span-2">
                <img class="w-full h-full object-cover object-center" src="{{facebookMedias[0].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[0])}">
            </div>  
            <div  class="gird grid-cols-3 col-span-1 gap-0">
                <img class="w-full h-1/3 object-cover object-center" src="{{facebookMedias[1].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[1])}">
                <img class="w-full h-1/3 object-cover object-center" src="{{facebookMedias[2].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[2])}">
                <img class="w-full h-1/3 object-cover object-center" src="{{facebookMedias[3].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[3])}">
            </div>
        </div>
        <div *ngIf="orientation=='square'" class="grid grid-cols-2 grid-rows-2 gap-0 " >
            <div class="w-full h-full">
                <img class="w-full h-full object-cover object-center" src="{{facebookMedias[0].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[0])}">
            </div>
            <div class="w-full h-full">
                <img class="w-full h-full object-cover object-center" src="{{facebookMedias[1].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[1])}">
            </div>
            <div class="w-full h-full">
                <img class="w-full h-full object-cover object-center" src="{{facebookMedias[2].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[2])}">
            </div>
            <div class="w-full h-full">
                <img class="w-full h-full object-cover object-center" src="{{facebookMedias[3].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[3])}">
            </div>
        </div>
    </div>
    <div *ngIf="facebookMedias.length>4">
        <div *ngIf="orientation == 'portrait' || orientation == 'square'" class="grid grid-rows-[60%_40%] gap-0 " >

            <!-- Première ligne avec deux images -->
            <div class="grid grid-cols-2 gap-0 max-h-[165px]">
                <div class="relative w-full ">
                    <img class=" inset-0 w-full  object-cover object-center" src="{{facebookMedias[0].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[0])}">
                </div>
                <div class="relative w-full ">
                    <img class=" inset-0 w-full  object-cover object-center" src="{{facebookMedias[1].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[1])}">
                </div>
            </div>
            <div class="grid grid-cols-3 gap-0 max-h-[165px]">
                <div class="relative w-full h-full">
                    <img class=" inset-0 w-full  object-cover object-center" src="{{facebookMedias[2].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[2])}">
                </div>
                <div class="relative w-full ">
                    <img class=" inset-0 w-full  object-cover object-center" src="{{facebookMedias[3].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[3])}">
                </div>
                <div class="relative w-full ">
                    <img *ngIf="facebookMedias.length == 5" class=" inset-0 w-full h-full object-cover object-center" src="{{facebookMedias[4].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[4])}">
                    <div *ngIf="facebookMedias.length > 5" class="relative w-full h-full">
                        <img class="absolute inset-0 w-full h-full object-cover object-center" src="{{facebookMedias[4].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[4])}">
                        <div class="absolute inset-0 bg-black bg-opacity-60 flex justify-center items-center">
                            <span class="text-white text-2xl">+{{facebookMedias.length - 4}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="orientation=='landscape'" class="grid grid-cols-2 gap-0 " >
            <div class="" >
                <img class="w-full h-1/2 object-cover object-center" src="{{facebookMedias[0].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[0])}">
                <img class="w-full h-1/2 object-cover object-center" src="{{facebookMedias[1].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[1])}">
            </div>  
            <div  class="gird grid-cols-3 gap-0">
                <img class="w-full h-1/3 object-cover object-center" src="{{facebookMedias[2].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[2])}">
                <img class="w-full h-1/3 object-cover object-center" src="{{facebookMedias[3].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[3])}">
                <img *ngIf="facebookMedias.length==5" class="w-full h-1/3 object-cover object-center" src="{{facebookMedias[4].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[4])}">
                <div *ngIf="facebookMedias.length>5" class="relative h-1/3">
                    <img class="w-full h-full object-cover object-center" src="{{facebookMedias[4].url}}" [ngClass]="{'checkboard':isPng(facebookMedias[4])}">
                    <div class="absolute inset-0 bg-black bg-opacity-60 flex justify-center items-center">
                        <span class="text-white text-2xl object-cover object-center">+{{facebookMedias.length-4}}</span>
                    </div>
                </div>
            </div>
        </div>    
    </div>
</div>
